import React from 'react'
import { observer } from "mobx-react"

const Home = observer(() => {


  return (
    <div className='home'>
      <h1>Hi Marley Internal Use Only</h1>
    </div>
  )
})

export default Home